import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Container, Space } from '@ag1/ui';
import { AnchorNavigation } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { getCardNumberText } from './utils';
import styles from './AnchorNavigation.module.scss';

type Props = {
  variant: AnchorNavigation['variant'];
  anchors: AnchorNavigation['anchors'];
  bgColor: AnchorNavigation['bgColor'];
  addNumbers: AnchorNavigation['addNumbers'];
  padding: AnchorNavigation['padding'];
  theme: AnchorNavigation['theme'];
  isActiveAnchor: (link: string) => boolean;
  setActiveLinkWithScroll: (link: string) => void;
};

export const CardsNavigation = forwardRef<HTMLDivElement, Props>(
  (
    {
      variant,
      anchors,
      bgColor,
      addNumbers,
      theme,
      padding,
      isActiveAnchor,
      setActiveLinkWithScroll
    },
    ref
  ) =>
    variant === 'cards' ? (
      <Space
        top={{ xxs: 0 }}
        bottom={{ xxs: 40, m: 120, l: 150 }}
        className={clsx(
          bgColor === 'stone' ? styles.stoneBg : '',
          getSectionPaddingClasses(styles, padding)
        )}>
        <nav
          className={clsx(
            styles.nav,
            getThemeCSSClass(theme),
            bgColor === 'stone' && styles.stoneBg
          )}
          role="navigation"
          data-variant="cards"
          ref={ref}>
          <Container narrow>
            <ul className={styles.list}>
              {anchors &&
                anchors.map((anchor, index) => (
                  <li
                    key={anchor.anchorTitle}
                    className={clsx(styles.listItem, getThemeCSSClass(theme))}>
                    <button
                      type="button"
                      className={clsx(
                        styles.buttonLink,
                        isActiveAnchor(anchor.anchorLink) && styles.active,
                        addNumbers && styles.withNumbers,
                        !addNumbers && styles.alignEnd,
                        getThemeCSSClass(theme)
                      )}
                      onClick={() => setActiveLinkWithScroll(anchor.anchorLink)}>
                      {variant === 'cards' && addNumbers && (
                        <span className={styles.number}>{getCardNumberText(index + 1)}</span>
                      )}
                      <span className={styles.text}>{anchor.anchorTitle}</span>
                    </button>
                  </li>
                ))}
            </ul>
          </Container>
        </nav>
      </Space>
    ) : null
);

CardsNavigation.displayName = 'CardsNavigation';
